import React, { useEffect, useState } from "react";
import { StateContext } from "context/context";
import { Overlay } from "interfaces";
import { dbLogError } from "hooks/dbLogError";
import { getDownloadImage } from "modules/ui";

interface Props {
    layer: number;
}

const noOverlay: Overlay = {
    name: "none",
    url: "none",
    path: "none"
};

const GeneralLayer: React.FC<Props> = ({ layer }) => {
    const [image, setImage] = useState("");
    const { state } = StateContext();
    const [loading, setLoading] = useState<boolean>(false);

    const overlaysList: Overlay[] = [noOverlay, ...state.event.overlays];

    const getLayer = async () => {
        setLoading(true);

        getDownloadImage(overlaysList[layer].url).then(response => {
            const url = response as string;

            setImage(url);
        }).catch(async (error) => {
            await dbLogError(error, 'error setting Signature Image signature-image.tsx');
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        getLayer();
    }, [layer]);

    return (
        <div>
            {loading ?
                <div style={{ position: "absolute", top: 0, left: 0, zIndex: 200, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div> :
                <img className="edit-photo__layer-image" src={image} alt="Layer creation" />
            }
        </div>
    );
};

export default GeneralLayer;